import { NetLogicTableConfiguration } from "@/core/NetLogicTableConfiguration";
import { QRCodeDrawer } from "./QRCodeDrawer";
import { EcleticaTableConfiguration } from "@/core/EcleticaTableConfiguration";
import { ColibriTableConfiguration } from "@/core/ColibriTableConfiguration";
import { useState } from "react";
import { Alert } from "@/components/Alert";
import { EnvironmentConfiguration } from "@/core/EnvironmentConfiguration";
import { SaiposTableConfiguration } from "@/core/SaiposTableConfiguration";

const Configurations = {
  NETLOGIC: NetLogicTableConfiguration,
  ECLETICA: EcleticaTableConfiguration,
  COLIBRI: ColibriTableConfiguration,
  SAIPOS: SaiposTableConfiguration
};

export function QRCodeConfigurationDrawer({ type, onClose, onUpdate }) {
  const [error, setError] = useState();

  const updateConfiguration = async ({ data }) => {
    if (Configurations[type] && data) {
      try {
        const configurationHandler = Configurations[type].fromStorage();
        configurationHandler.import(data);
        
        const environmentHandler = EnvironmentConfiguration.fromStorage();
        await environmentHandler.import(data);

        onUpdate();
      } catch (err) {
        setError({
          title: "Falha na configuração",
          message: err.message,
        });
      }
    }
  };

  const title = `${type} - QR Code`;

  return (
    <>
      <QRCodeDrawer
        title={title}
        onClose={onClose}
        onScan={(data) => updateConfiguration(data)}
        onError={(err) => setError(err)}
      />

      <Alert
        title={error?.title}
        subtitle={error?.message}
        open={!!error}
        onClose={() => setError(null)}
      />
    </>
  );
}
